import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useShowContext } from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { SetCredentialsDialog } from '../OfflineServerDialogs'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const OfflineServerSetCredentialsButton = () => {
  const { loading } = useShowContext()
  const classes = useStyles()
  const [credentialsModalOpen, setCredentialsModalOpen] = useState(false)
  const hasAuthority = useHasAuthority()

  const handleSetCredentialsDialog = () => {
    setCredentialsModalOpen(true)
  }

  return (
    <>
      <SetCredentialsDialog
        open={credentialsModalOpen}
        close={() => setCredentialsModalOpen(false)}
      />
      <Button
        variant="contained"
        onClick={handleSetCredentialsDialog}
        color="primary"
        className={classes.button}
        label="resources.offline-servers.actions.setCredentials"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.OFFLINE_SERVERS_MANAGE_CREDENTIALS_BUTTON) ||
          loading
        }
      />
    </>
  )
}
